import { CS } from "../../../base/utils/styler";

export const baseStyle: CS = {
    display: 'flex',
    flexDirection: 'row',    
    alignItems: 'center',
    gap: '10px',
    marginTop: '12px'
}